import { Box, styled, SvgIcon, Typography, useTheme } from '@mui/material';
import * as React from 'react';

import { ReactComponent as CurrencyIcon } from '../../../assets/images/icon-currency-exchange.svg';
import { MuiCurrencySelector } from '../_components_/index';

interface IProps {
  height?: number;
  mobileSideNav?: boolean;
}

const Container = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'customHeight',
})<{ customHeight?: number }>(({ customHeight }) => ({
  display: 'flex',
  alignItems: 'center',
  height: customHeight || 56,
  width: '100%',
  justifyContent: 'space-between',
  flexShrink: 0,
  minWidth: '100%',
}));

const IconContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 24,
  height: 24,
  flexShrink: 0,
});

const Label = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'mobileSideNav',
})<{ mobileSideNav?: boolean }>(({ theme: { wl, typography, spacing, palette }, mobileSideNav }) => ({
  fontSize: 14,
  fontWeight: typography.fontWeightMedium,
  color: mobileSideNav ? wl?.portal_sidebar_text_color : palette.text.secondary,
  whiteSpace: 'nowrap',
  marginLeft: spacing(1.5),
}));

export const DisplayCurrencyMenuItem: React.FC<IProps> = ({ height, mobileSideNav }) => {
  const { wl, palette } = useTheme();

  const iconStyles = {
    width: 10,
    height: 5,
    color: mobileSideNav ? wl?.portal_sidebar_text_color : palette.action.active,
  };

  return (
    <Container customHeight={height}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <IconContainer>
          <SvgIcon component={CurrencyIcon} sx={iconStyles} />
        </IconContainer>
        <Label mobileSideNav={mobileSideNav}>Display currency</Label>
      </Box>
      <MuiCurrencySelector />
    </Container>
  );
};
